import { fokaAxios } from 'app/fokaAxios'

const apiPathMap = {
  AD_ACCOUNT: 'accounts',
  AD_GROUP: 'adgroups',
  CAMPAIGN: 'campaigns',
  CREATIVE: 'creatives',
  KEYWORD: 'keywords',
}
export default {
  getReportsCustom: params =>
    fokaAxios.get('/api/v2/reports/custom', { params }),
  addReport: param => fokaAxios.post('/api/v2/reports/custom', param),
  modifyReport: ({ customReportId, param }) =>
    fokaAxios.put(`/api/v2/reports/custom/${customReportId}`, param),
  deleteReport: id => fokaAxios.delete(`/api/v2/reports/custom/${id}`),
  getDomainReports: ({ domain, page, size, param }) =>
    fokaAxios.post(`/api/v2/reports/custom/${apiPathMap[domain]}`, param, {
      params: {
        page,
        limit: size,
      },
    }),
  downloadDomainReports: ({ domain, param }) =>
    fokaAxios.post(
      `/api/v2/reports/custom/${apiPathMap[domain]}/download`,
      param
    ),
  getDomainReportsById: ({ domainPathVariable, reportIdPathVariable }) =>
    fokaAxios.get(
      `/api/v2/reports/custom/${apiPathMap[domainPathVariable]}/${reportIdPathVariable}`
    ),
}
